// extracted by mini-css-extract-plugin
export default {"addressAction":"R6-z","loading":"S6-z"};